export const GET_BRANDS = 'providers/root/BrandsProvider/GET_BRANDS';
export const SELECTED_BRAND = 'providers/root/BrandsProvider/SELECTED_BRAND';
